import React from 'react'
import PropTypes from 'prop-types'


const Truncate = ({text, maxLength}) => {


    let result = text

    if (text.length > maxLength)
        result = text.substr(0, maxLength) + '...'

    return (
        <React.Fragment>
            {result}
        </React.Fragment>
    )
}

Truncate.propTypes = {
    text: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
}

Truncate.defaultProps = {
    maxLength: 150
}

export default Truncate



// WEBPACK FOOTER //
// ./src/components/_common/Truncate/index.js